const DataTable = ({ columns, rows, renderRow, emptyText = 'Sin resultados', loading = false }) => (
  <div className='rounded-xl overflow-hidden bg-white'>
    <div className='overflow-x-auto'>
      <table className='min-w-full text-sm'>
        <thead className=''>
          <tr>
            {columns.map(column => (
              <th key={column} className='uppercase px-4 py-2 text-center font-semibold text-slate-700 border-b border-slate-200'>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <td colSpan={columns.length} className='px-4 py-6 text-center text-slate-500'>
                Cargando...
              </td>
            </tr>
          )}
          {!loading && rows.length === 0 && (
            <tr>
              <td colSpan={columns.length} className='px-4 py-6 text-center text-slate-500'>
                {emptyText}
              </td>
            </tr>
          )}
          {!loading &&
            rows.map((row, index) => (
              <tr key={row?.id ?? `${index}-${row?.sku ?? row?.code ?? 'row'}`} className='border-t border-gray-100 text-center'>
                {renderRow(row)}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  </div>
)

export default DataTable
